import React from 'react';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { useWeeklyHoursSummary } from './useWeeklyHoursSummary';
export var WeeklyHoursSummary = function (_a) {
    var totalDuration = _a.totalDuration, workedDuration = _a.workedDuration, scheduledDuration = _a.scheduledDuration;
    var t = useTranslation().t;
    var _b = useWeeklyHoursSummary({
        totalDuration: totalDuration,
        workedDuration: workedDuration,
        scheduledDuration: scheduledDuration
    }), totalHours = _b.totalHours, workedHours = _b.workedHours, scheduledHours = _b.scheduledHours;
    return (React.createElement(StyledRow, null,
        React.createElement(WidthWrapper, { gridGap: "S300" },
            React.createElement(TotalHoursText, { dataTestId: "WeeklyHoursSummary-totalHours" }, t('shift_management_features_weeklyHoursSummary_totalHours', {
                totalHours: totalHours
            })),
            React.createElement(HoursBreakdownText, { dataTestId: "WeeklyHoursSummary-hoursBreakdown" }, t('shift_management_features_weeklyHoursSummary_hoursBreakdown', {
                workedHours: workedHours,
                scheduledHours: scheduledHours
            })))));
};
var StyledRow = styledWithTheme(Row)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        border-top: 1px solid ".concat(selectors.color('neutral20'), ";\n        border-bottom: 1px solid ").concat(selectors.color('neutral20'), ";\n        background-color: ").concat(selectors.color('neutral05'), ";\n    ");
});
var WidthWrapper = styledWithTheme(Row)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        margin: 0 auto;\n        max-width: 1140px;\n        width: 100%;\n        padding: ".concat(selectors.space('S200'), "px ").concat(selectors.space('S400'), "px;\n        text-align: left;\n    ");
});
var TotalHoursText = styledWithTheme(Text)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        color: ".concat(selectors.color('neutral100'), ";\n        font-size: ").concat(selectors.fontSize('T200'), ";\n        font-weight: ").concat(selectors.fontWeight('bold'), ";\n        line-height: ").concat(selectors.lineHeight('T200'), ";\n    ");
});
var HoursBreakdownText = styledWithTheme(Text)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        color: ".concat(selectors.color('neutral100'), ";\n        font-size: ").concat(selectors.fontSize('T200'), ";\n        line-height: ").concat(selectors.lineHeight('T200'), ";\n    ");
});
